module.exports = __webpack_public_path__ + "SC012.c6e51bc1.png";